import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { Badge } from '.';
export function AppBenefitsBadge({ showBorder, appName, size = 'small', }) {
    const { t } = useEssentials();
    return (React.createElement(Badge, { skin: "neutralSuccess", dataHook: "app-benefit-badge", uppercase: false, showBorder: showBorder, size: size, tooltipContent: React.createElement(Box, { direction: "vertical", gap: "6px" },
            React.createElement(Text, { size: "small", weight: "thin", skin: "light" }, t('app.benefits.badge.tooltip', { appName }))) },
        React.createElement(Box, { marginTop: "2px" }, t('app.benefits.badge'))));
}
//# sourceMappingURL=app-benefits-badge.js.map